import { Injectable } from "@angular/core";
import { IPrivileges } from "src/app/core/models/iuser";
import { ClaimsPermissions } from "src/app/core/roles/claims-permissions";
import { ClientsPermissions } from "src/app/core/roles/clients-permissions";
import { CustomerServicePermissions } from "src/app/core/roles/customer-service-permissions";
import { MasterTablePermissions } from "src/app/core/roles/master-table-permissions";
import { ProductionPermissions } from "src/app/core/roles/production-permissions";
import { MenuItem } from "src/app/layouts/sidebar/menu.model";
import { BusinessDevelopmentPermissions } from "src/app/core/roles/business-development-permissions";
import { AppRoutes } from "../app/routers/appRouters";
import { FinanceFormTypes } from "../app/models/Finance/finance-utils";
import { SystemAdminPermissions } from "src/app/core/roles/system-admin-permissions";
import { FinancePermissions } from "src/app/core/roles/finance-permissions";

@Injectable({
  providedIn: "root",
})
export class MenuService {
  getMenu(privileges: IPrivileges): MenuItem[] {
    return [
      {
        id: 1,
        label: "MENUITEMS.MASTERTABLE.TEXT",
        icon: "ri-layout-grid-line",
        auth: privileges.MasterTables?.includes(
          MasterTablePermissions.ChMasterTabels,
        ),
        subItems: [
          {
            id: 101,
            label: "MENUITEMS.MASTERTABLE.LIST.INSURANCEPRODUCTS.TEXT",
            parentId: 1,
            auth: true,
            subItems: [
              {
                id: 1001,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.INSURANCEPRODUCTS.LIST.INSURANCECLASSES",
                link: AppRoutes.MasterTable.insuranceClasses,
                parentId: 101,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChIncuranceClasses,
                ),
              },
              {
                id: 1002,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.INSURANCEPRODUCTS.LIST.LINEOFBUSINESS",
                link: AppRoutes.MasterTable.lineOfBusiness,
                parentId: 101,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChIncuranceClasses,
                ),
              },
            ],
          },
          {
            id: 103,
            label: "MENUITEMS.MASTERTABLE.LIST.INSURANCECOMPANIES",
            link: AppRoutes.MasterTable.insuranceCompanies,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChInsuranceCompanies,
            ),
          },
          {
            id: 104,
            label: "MENUITEMS.MASTERTABLE.LIST.INSURANCEBROKERS",
            link: AppRoutes.MasterTable.insuranceBrokers,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChInsuranceBrokers,
            ),
          },
          {
            id: 105,
            label: "MENUITEMS.MASTERTABLE.LIST.POLICYTYPES",
            link: AppRoutes.MasterTable.policyTypes,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
          },
          {
            id: 109,
            label: "MENUITEMS.MASTERTABLE.LIST.LOCATIONS",
            link: AppRoutes.MasterTable.locations,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
          },
          {
            id: 121,
            label: "MENUITEMS.MASTERTABLE.LIST.CLIENTS.TEXT",
            parentId: 1,
            auth: true,
            subItems: [
              {
                id: 1021,
                label: "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.NATIONALITIES",
                link: AppRoutes.MasterTable.nationalities,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChMasterTabels,
                ),
              },
              {
                id: 1022,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.BUSINESSACTIVITY",
                link: AppRoutes.MasterTable.businessActivity,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChBusinessActivity,
                ),
              },
              {
                id: 1023,
                label: "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.LEGALSTATUS",
                link: AppRoutes.MasterTable.legalStatus,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChMasterTabels,
                ),
              },
              {
                id: 1024,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.CLIENTCATEGORIES",
                link: AppRoutes.MasterTable.clientCategories,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClientsCategories,
                ),
              },
              {
                id: 1025,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.CONTACTSLISTPOSITION",
                link: AppRoutes.MasterTable.contactsListPosition,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChContactsListPosition,
                ),
              },
              {
                id: 1026,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLIENTS.LIST.LISTOFDOCUMENTS",
                link: AppRoutes.MasterTable.listOfDocuments.clients,
                parentId: 121,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChListOfRequiredDocuments,
                ),
              },
            ],
          },
          {
            id: 110,
            label: "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.TEXT",
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
            subItems: [
              {
                id: 1010,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.SALES.TEXT",
                parentId: 110,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChMasterTabels,
                ),
                subItems: [
                  {
                    id: 10010,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.SALES.QUOTINGREQUIREMENTS",
                    link: AppRoutes.MasterTable.businessDevelopment.Sales
                      .QuotingRequirements,
                    parentId: 1010,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                  {
                    id: 10011,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.SALES.POLICYISSUANCEREQUIREMENTS",
                    link: AppRoutes.MasterTable.businessDevelopment.Sales
                      .PolicyIssuanceRequirements,
                    parentId: 1010,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                  {
                    id: 10012,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.SALES.PROSPECTLOSSREASONS",
                    link: AppRoutes.MasterTable.businessDevelopment.Sales
                      .ProspectLossReasons,
                    parentId: 1010,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                ],
              },
              {
                id: 1011,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.INSURANCESLIPBUILDER.TEXT",
                link: AppRoutes.MasterTable.businessDevelopment
                  .insuranseSlipsBuilder,
                parentId: 110,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChMasterTabels,
                ),
              },
              {
                id: 1012,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.CANCELLATION/REJECTIONREASONS.TEXT",
                parentId: 110,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChMasterTabels,
                ),
                subItems: [
                  {
                    id: 10010,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.CANCELLATION/REJECTIONREASONS.COMPANYREJECTIONREASONS",
                    link: AppRoutes.MasterTable.businessDevelopment
                      .CancellationRejectionReasons.CompanyRejectionReasons,
                    parentId: 1012,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                  {
                    id: 10011,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.CANCELLATION/REJECTIONREASONS.CLIENTREJECTIONREASONS",
                    link: AppRoutes.MasterTable.businessDevelopment
                      .CancellationRejectionReasons.ClientRejectionReasons,
                    parentId: 1012,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                  {
                    id: 10012,
                    label:
                      "MENUITEMS.MASTERTABLE.LIST.BUSINESSDEVELOPMENT.CANCELLATION/REJECTIONREASONS.CANCELLATIONREASONS",
                    link: AppRoutes.MasterTable.businessDevelopment
                      .CancellationRejectionReasons.CancellationReasons,
                    parentId: 1013,
                    auth: privileges.MasterTables?.includes(
                      MasterTablePermissions.ChMasterTabels,
                    ),
                  },
                ],
              },
            ],
          },
          {
            id: 112,
            label: "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.TEXT",
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChCustomerServiceModule,
            ),
            subItems: [
              {
                id: 1012,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.INSURANCECOMPANIESDOCUMENTS",
                link: AppRoutes.MasterTable.customerService
                  .insuranceCompaniesDocuments,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1013,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.CUSTOMERSERVICEREQUIREMENTS",
                link: AppRoutes.MasterTable.customerService
                  .customerServiceRequirements,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1014,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.COMPLAINTSTYPES",
                link: AppRoutes.MasterTable.customerService.complaintsTypes,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1015,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.COMPLAINTSSETTINGS",
                link: AppRoutes.MasterTable.customerService.complaintsSettings,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1016,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.COMPLAINTSSUSPECTIVECAUSES",
                link: AppRoutes.MasterTable.customerService
                  .complaintsSuspectiveCauses,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1017,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.CUSTOMERSERVICERECANCELLATIONREASONS",
                link: AppRoutes.MasterTable.customerService
                  .customerServiceCancellationReason,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
              {
                id: 1018,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CUSTOMERSERVICE.CUSTOMERSERVICEPENDINGREASONS",
                link: AppRoutes.MasterTable.customerService
                  .customerServicePendingReason,
                parentId: 112,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChCustomerServiceModule,
                ),
              },
            ],
          },
          {
            id: 113,
            label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.TEXT",
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChProductionBusinessModules,
            ),
            subItems: [
              {
                id: 1013,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFCOVERS",
                link: AppRoutes.MasterTable.production.libraryOfCovers,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1014,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFINTERESTSINSURED",
                link: AppRoutes.MasterTable.production
                  .libraryOfInterestsInsured,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1015,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFTERMS",
                link: AppRoutes.MasterTable.production.libraryOfTerms,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1016,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFDEDUCTIBLES",
                link: AppRoutes.MasterTable.production.libraryOfDeductibles,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1017,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFEXCLUSIONS",
                link: AppRoutes.MasterTable.production.libraryOfExclusions,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1018,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIBRARYOFWARRANTIES",
                link: AppRoutes.MasterTable.production.libraryOfWarranties,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1019,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LIFEPLAN",
                link: AppRoutes.MasterTable.production.lifePlan,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1020,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.VEHICLESMAKE",
                link: AppRoutes.MasterTable.production.vehiclesMake,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1021,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.VEHICLESTYPE",
                link: AppRoutes.MasterTable.production.vehiclesType,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1022,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.VEHICLESCOLOR",
                link: AppRoutes.MasterTable.production.vehiclesColor,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChProductionBusinessModules,
                ),
              },
              {
                id: 1023,
                label: "MENUITEMS.MASTERTABLE.LIST.PRODUCTION.LISTOFDOCUMENTS",
                link: AppRoutes.MasterTable.listOfDocuments.production,
                parentId: 113,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChListOfRequiredDocuments,
                ),
              },
            ],
          },
          {
            id: 114,
            label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.TEXT",
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChClaimsModule,
            ),
            subItems: [
              {
                id: 1014,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.CARSMAKER",
                link: AppRoutes.MasterTable.claims.carsMaker,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1015,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.HOSPITALS",
                link: AppRoutes.MasterTable.claims.hospitals,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1016,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLAIMS.INSURANCEWORKSHOPDETAILS",
                link: AppRoutes.MasterTable.claims.insuranceWorkShopDetails,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1017,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.TPALIST",
                link: AppRoutes.MasterTable.claims.tpaList,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1018,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.CLAIMSGENERALITEMS",
                link: AppRoutes.MasterTable.claims.claimsGeneralItems,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1019,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.CLAIMSSTATUS",
                link: AppRoutes.MasterTable.claims.claimsStatus,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1020,
                label:
                  "MENUITEMS.MASTERTABLE.LIST.CLAIMS.CLAIMSREJECTIONREASONS",
                link: AppRoutes.MasterTable.claims.claimsRejectionReasons,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChClaimsModule,
                ),
              },
              {
                id: 1021,
                label: "MENUITEMS.MASTERTABLE.LIST.CLAIMS.LISTOFDOCUMENTS",
                link: AppRoutes.MasterTable.listOfDocuments.claims,
                parentId: 114,
                auth: privileges.MasterTables?.includes(
                  MasterTablePermissions.ChListOfRequiredDocuments,
                ),
              },
            ],
          },
          {
            id: 116,
            label: "MENUITEMS.MASTERTABLE.LIST.VEHICLESTYPES",
            link: AppRoutes.MasterTable.vehiclesTypes,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
          },
          {
            id: 118,
            label: "MENUITEMS.MASTERTABLE.LIST.CITIES",
            link: AppRoutes.MasterTable.cities,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChCountries,
            ),
          },
          {
            id: 119,
            label: "MENUITEMS.MASTERTABLE.LIST.DEFAULTEMAILS",
            link: AppRoutes.MasterTable.defaultEmails,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChDefaultEmails,
            ),
          },
          {
            id: 120,
            label: "MENUITEMS.MASTERTABLE.LIST.BANKSETTINGS",
            link: AppRoutes.MasterTable.bankSettings,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
          },
          {
            id: 121,
            label: "MENUITEMS.MASTERTABLE.LIST.SEGMENT",
            link: AppRoutes.MasterTable.segment,
            parentId: 1,
            auth: privileges.MasterTables?.includes(
              MasterTablePermissions.ChMasterTabels,
            ),
          },
        ],
      },
      {
        id: 2,
        label: "MENUITEMS.CLIENTREGISTRY.TEXT",
        icon: "ri-folder-user-line",
        auth: privileges.Clients?.includes(
          ClientsPermissions.ChClientsRegistryAdmin,
        ),
        subItems: [
          {
            id: 201,
            label: "MENUITEMS.CLIENTREGISTRY.LIST.CLIENTREGISTRY",
            link: AppRoutes.Client.clientRegistry,
            parentId: 2,
            auth: privileges.Clients?.includes(
              ClientsPermissions.ChClientsRegistry,
            ),
          },
          {
            id: 202,
            label: "MENUITEMS.CLIENTREGISTRY.LIST.CLIENTGROUPS",
            link: AppRoutes.Client.groups,
            parentId: 2,
            auth: privileges.Clients?.includes(
              ClientsPermissions.ChClientsGrouping,
            ),
          },
          {
            id: 203,
            label: "MENUITEMS.CLIENTREGISTRY.LIST.REPORTS",
            link: AppRoutes.Client.reports,
            parentId: 2,
            auth: privileges.Clients?.includes(
              ClientsPermissions.ChClientsRegistryAdmin,
            ),
          },
        ],
      },
      {
        id: 3,
        label: "MENUITEMS.BUSINESSDEVELOPMENT.TEXT",
        icon: "ri-briefcase-5-line",
        auth: true,
        subItems: [
          // {
          //   id: 301,
          //   label: "MENUITEMS.BUSINESSDEVELOPMENT.LIST.DASHBOARD",
          //   link: AppRoutes.BusinessDevelopment.dashboard,
          //   parentId: 3,
          //   auth: true,
          // },
          {
            id: 302,
            label: "MENUITEMS.BUSINESSDEVELOPMENT.LIST.MANAGEMENT",
            link: AppRoutes.BusinessDevelopment.management,
            parentId: 3,
            auth: privileges.BussinessDevelopment?.includes(
              BusinessDevelopmentPermissions.ChBussDevelopment,
            ),
          },
          {
            id: 303,
            label: "MENUITEMS.BUSINESSDEVELOPMENT.LIST.SLIPS",
            link: AppRoutes.Slips.base,
            parentId: 3,
            auth: privileges.BussinessDevelopment?.includes(
              BusinessDevelopmentPermissions.ChUnderwritingDepartment,
            ),
          },
          {
            id: 304,
            label: "MENUITEMS.BUSINESSDEVELOPMENT.LIST.REPORTS",
            parentId: 3,
            auth: privileges.BussinessDevelopment?.includes(
              BusinessDevelopmentPermissions.ChBusinessReports,
            ),
            subItems: [
              {
                id: 3001,
                label:
                  "MENUITEMS.BUSINESSDEVELOPMENT.LIST.REPORTLIST.BUSINESSDEVELOPMENT",
                link: AppRoutes.BusinessDevelopment.reports.business,
                parentId: 302,
                auth: true,
              },
              {
                id: 3002,
                label: "MENUITEMS.BUSINESSDEVELOPMENT.LIST.REPORTLIST.RENEWAL",
                link: AppRoutes.BusinessDevelopment.reports.renewal,
                parentId: 302,
                auth: true,
              },
            ],
          },
        ],
      },
      {
        id: 4,
        label: "MENUITEMS.PRODUCTION.TEXT",
        icon: "bx bx-layer",
        auth: privileges.Production?.includes(
          ProductionPermissions.ChProduction,
        ),
        subItems: [
          {
            id: 401,
            label: "MENUITEMS.PRODUCTION.LIST.MANAGEMENT",
            link: AppRoutes.Production.base,
            parentId: 4,
            auth: privileges.Production?.includes(
              ProductionPermissions.ChProdPolicies,
            ),
          },
          {
            id: 402,
            label: "MENUITEMS.PRODUCTION.LIST.ACTIVELISTMANAGEMENT",
            link: AppRoutes.Production.activeList,
            parentId: 4,
            auth: privileges.Production?.includes(
              ProductionPermissions.ChProdPolicies,
            ),
          },
          {
            id: 403,
            label: "MENUITEMS.PRODUCTION.LIST.EDITCOMMISSIONS",
            link: AppRoutes.Production.editCommissions,
            parentId: 4,
            auth: privileges.Production?.includes(
              ProductionPermissions.ChChangeProducerComm,
            ),
          },
          {
            id: 404,
            label: "MENUITEMS.PRODUCTION.LIST.REPORTS",
            parentId: 4,
            auth: privileges.Production?.includes(
              ProductionPermissions.ChProdReports,
            ),
            subItems: [
              {
                id: 4001,
                label: "MENUITEMS.PRODUCTION.LIST.REPORTLIST.PRODUCTION",
                link: AppRoutes.Production.reports.production,
                parentId: 404,
                auth: true,
              },
              {
                id: 4002,
                label: "MENUITEMS.PRODUCTION.LIST.REPORTLIST.RENEWAL",
                link: AppRoutes.Production.reports.renewal,
                parentId: 404,
                auth: true,
              },
              {
                id: 4003,
                label: "MENUITEMS.PRODUCTION.LIST.REPORTLIST.RENEWALNOTICE",
                link: AppRoutes.Production.reports.renewalsNotice,
                parentId: 404,
                auth: true,
              },
            ],
          },
          {
            id: 405,
            label: "MENUITEMS.PRODUCTION.LIST.ARCHIVES",
            parentId: 4,
            auth: privileges.Production?.includes(
              ProductionPermissions.ChProdReports,
            ),
            subItems: [
              {
                id: 4001,
                label: "MENUITEMS.PRODUCTION.LIST.ARCHIVESLIST.DCNOTES",
                link: AppRoutes.Production.reports.archive.dcNote,
                parentId: 405,
                auth: true,
              },
            ],
          },
        ],
      },
      {
        id: 5,
        label: "MENUITEMS.CUSTOMERSERVICE.TEXT",
        icon: "ri-customer-service-2-line",
        auth: privileges.CustomerService?.includes(
          CustomerServicePermissions.ChCustomerService,
        ),
        subItems: [
          {
            id: 501,
            label: "MENUITEMS.CUSTOMERSERVICE.LIST.MANAGEMENT",
            link: AppRoutes.CustomerService.base,
            parentId: 5,
            auth: privileges.CustomerService?.includes(
              CustomerServicePermissions.ChRequestsManagements,
            ),
          },
          {
            id: 503,
            label: "MENUITEMS.CUSTOMERSERVICE.LIST.ONLINEREQUESTSMANAGEMENT",
            link: AppRoutes.CustomerService.online,
            parentId: 5,
            auth: privileges.CustomerService?.includes(
              CustomerServicePermissions.ChCustomerService,
            ),
          },
          {
            id: 504,
            label: "MENUITEMS.CUSTOMERSERVICE.LIST.COMPLAINTSRegistry",
            link: AppRoutes.CustomerService.complaints,
            parentId: 5,
            auth: privileges.CustomerService?.includes(
              CustomerServicePermissions.ChRequestsManagements,
            ),
          },
          {
            id: 505,
            label: "MENUITEMS.CUSTOMERSERVICE.LIST.ONLINECOMPLAINTS",
            link: AppRoutes.CustomerService.onlineComplaints,
            parentId: 5,
            auth: privileges.CustomerService?.includes(
              CustomerServicePermissions.ChCustSerReports,
            ),
          },
          {
            id: 502,
            label: "MENUITEMS.CUSTOMERSERVICE.LIST.REPORTS",
            link: AppRoutes.CustomerService.reports,
            parentId: 5,
            auth: privileges.CustomerService?.includes(
              CustomerServicePermissions.ChCustSerReports,
            ),
          },
        ],
      },
      {
        id: 6,
        label: "MENUITEMS.CLAIMS.TEXT",
        icon: "ri-file-copy-2-line",
        auth: privileges.Claims?.includes(ClaimsPermissions.ChClaims),
        subItems: [
          {
            id: 601,
            label: "MENUITEMS.CLAIMS.LIST.MANAGEMENT",
            link: AppRoutes.Claims.base,
            parentId: 6,
            auth: privileges.Claims?.includes(
              ClaimsPermissions.ChClaimsManagement,
            ),
          },
          {
            id: 603,
            label: "MENUITEMS.CLAIMS.LIST.ONLINECLAIMSMANAGEMENT",
            link: AppRoutes.Claims.onlineClaims,
            parentId: 6,
            auth: privileges.Claims?.includes(
              ClaimsPermissions.ChClaimsManagement,
            ),
          },
          {
            id: 602,
            label: "MENUITEMS.CLAIMS.LIST.REPORTS",
            link: AppRoutes.Claims.reports,
            parentId: 6,
            auth: privileges.Claims?.includes(ClaimsPermissions.ChClaimsReport),
          },
        ],
      },
      // {
      //   id: 7,
      //   label: "MENUITEMS.FINANCE.TEXT",
      //   icon: "mdi mdi-currency-usd",
      //   auth: privileges.Finance?.includes(FinancePermissions.ChFinance),
      //   subItems: [
      //     {
      //       id: 701,
      //       label: "MENUITEMS.FINANCE.LIST.CHARTOFACCOUNT",
      //       link: AppRoutes.finance.chartOfAccounts,
      //       parentId: 7,
      //       auth: true,
      //     },
      //     {
      //       id: 702,
      //       label: "MENUITEMS.FINANCE.LIST.RENAMEACCOUNTS",
      //       link: AppRoutes.finance.chartOfAccounts,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 703,
      //       label: "MENUITEMS.FINANCE.LIST.APPROVEINSURANCECOMPANY",
      //       link: AppRoutes.finance.chartOfAccounts,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 704,
      //       label: "MENUITEMS.FINANCE.LIST.CLIENTSCHASING",
      //       link: AppRoutes.finance.clientsChasing,
      //       parentId: 7,
      //       auth: true,
      //     },
      //     {
      //       id: 705,
      //       label: "MENUITEMS.FINANCE.LIST.SENDCLIENTSSOAEMAIL",
      //       link: AppRoutes.finance.chartOfAccounts,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 706,
      //       label: "MENUITEMS.FINANCE.LIST.STAFFPROFILEVIEW",
      //       link: AppRoutes.finance.chartOfAccounts,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 707,
      //       label: "MENUITEMS.FINANCE.LIST.MAKENEW.TEXT",
      //       parentId: 7,
      //       auth: true,
      //       subItems: [
      //         {
      //           id: 7071,
      //           label: "MENUITEMS.FINANCE.LIST.MAKENEW.LIST.JOURNALVOUCHER",
      //           link: `${AppRoutes.finance.journalVoucher}/${FinanceFormTypes.create}`,
      //           parentId: 707,
      //           auth: true,
      //         },
      //         {
      //           id: 7072,
      //           label: "MENUITEMS.FINANCE.LIST.MAKENEW.LIST.RECEIPTVOUCHERS",
      //           link: `${AppRoutes.finance.receiptVoucher}/${FinanceFormTypes.create}`,
      //           parentId: 707,
      //           auth: true,
      //         },
      //         {
      //           id: 7073,
      //           label: "MENUITEMS.FINANCE.LIST.MAKENEW.LIST.RECEIPTPRODUCTION",
      //           link: `${AppRoutes.finance.receiptProduction}/${FinanceFormTypes.create}`,
      //           parentId: 707,
      //           auth: true,
      //         },
      //         {
      //           id: 7074,
      //           label: "MENUITEMS.FINANCE.LIST.MAKENEW.LIST.PAYVOUCHERS",
      //           link: `${AppRoutes.finance.payVouchers}/${FinanceFormTypes.create}`,
      //           parentId: 707,
      //           auth: true,
      //         },
      //         {
      //           id: 7075,
      //           label: "MENUITEMS.FINANCE.LIST.MAKENEW.LIST.PAYVRPRODUCTION",
      //           link: `${AppRoutes.finance.payVRProduction}/${FinanceFormTypes.create}`,
      //           parentId: 707,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 708,
      //       label: "MENUITEMS.FINANCE.LIST.CORRECTING.TEXT",
      //       parentId: 7,
      //       auth: true,
      //       subItems: [
      //         {
      //           id: 7081,
      //           label: "MENUITEMS.FINANCE.LIST.CORRECTING.LIST.JOURNALVOUCHERS",
      //           link: `${AppRoutes.finance.journalVoucher}/${FinanceFormTypes.correcting}`,
      //           parentId: 708,
      //           auth: true,
      //         },
      //         {
      //           id: 7082,
      //           label: "MENUITEMS.FINANCE.LIST.CORRECTING.LIST.RECEIPTVOUCHERS",
      //           link: `${AppRoutes.finance.receiptVoucher}/${FinanceFormTypes.correcting}`,
      //           parentId: 708,
      //           auth: true,
      //         },
      //         {
      //           id: 7082,
      //           label:
      //             "MENUITEMS.FINANCE.LIST.CORRECTING.LIST.RECEIPTPRODUCTION",
      //           link: `${AppRoutes.finance.receiptProduction}/${FinanceFormTypes.correcting}`,
      //           parentId: 708,
      //           auth: true,
      //         },
      //         {
      //           id: 7083,
      //           label: "MENUITEMS.FINANCE.LIST.CORRECTING.LIST.PAYVOUCHERS",
      //           link: `${AppRoutes.finance.payVouchers}/${FinanceFormTypes.correcting}`,
      //           parentId: 708,
      //           auth: true,
      //         },
      //         {
      //           id: 7084,
      //           label: "MENUITEMS.FINANCE.LIST.CORRECTING.LIST.PAYVRPRODUCTION",
      //           link: `${AppRoutes.finance.payVRProduction}/${FinanceFormTypes.correcting}`,
      //           parentId: 708,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 709,
      //       label: "MENUITEMS.FINANCE.LIST.APPROVING.TEXT",
      //       parentId: 7,
      //       auth: true,
      //       subItems: [
      //         {
      //           id: 7091,
      //           label: "MENUITEMS.FINANCE.LIST.APPROVING.LIST.JOURNALVOUCHERS",
      //           link: `${AppRoutes.finance.journalVoucher}/${FinanceFormTypes.approving}`,
      //           parentId: 709,
      //           auth: true,
      //         },
      //         {
      //           id: 7092,
      //           label: "MENUITEMS.FINANCE.LIST.APPROVING.LIST.RECEIPTVOUCHERS",
      //           link: `${AppRoutes.finance.receiptVoucher}/${FinanceFormTypes.approving}`,
      //           parentId: 709,
      //           auth: true,
      //         },
      //         {
      //           id: 7093,
      //           label:
      //             "MENUITEMS.FINANCE.LIST.APPROVING.LIST.RECEIPTPRODUCTION",
      //           link: `${AppRoutes.finance.receiptProduction}/${FinanceFormTypes.approving}`,
      //           parentId: 709,
      //           auth: true,
      //         },
      //         {
      //           id: 7094,
      //           label: "MENUITEMS.FINANCE.LIST.APPROVING.LIST.PAYVOUCHERS",
      //           link: `${AppRoutes.finance.payVouchers}/${FinanceFormTypes.approving}`,
      //           parentId: 709,
      //           auth: true,
      //         },
      //         {
      //           id: 7095,
      //           label: "MENUITEMS.FINANCE.LIST.APPROVING.LIST.PAYVRPRODUCTION",
      //           link: `${AppRoutes.finance.payVRProduction}/${FinanceFormTypes.approving}`,
      //           parentId: 709,
      //           auth: true,
      //         },
      //         {
      //           id: 7098,
      //           label:
      //             "MENUITEMS.FINANCE.LIST.APPROVING.LIST.PRODUCTIONENTRIES",
      //           link: AppRoutes.finance.productionEntries,
      //           parentId: 709,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 710,
      //       label: "MENUITEMS.FINANCE.LIST.CHEQUESMANAGEMENT",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: true,
      //     },
      //     {
      //       id: 711,
      //       label: "MENUITEMS.FINANCE.LIST.REPORTS.TEXT",
      //       link: AppRoutes.finance.reports.base,
      //       parentId: 7,
      //       auth: true,
      //       subItems: [
      //         {
      //           id: 7111,
      //           label: "MENUITEMS.FINANCE.LIST.REPORTS.LIST.PREVIEWVOUCHER",
      //           link: AppRoutes.finance.reports.previewVoucher,
      //           parentId: 711,
      //           auth: false,
      //         },
      //         {
      //           id: 7112,
      //           label: "MENUITEMS.FINANCE.LIST.REPORTS.LIST.LISTOFVOUCHERS",
      //           link: AppRoutes.finance.reports.listOfVouchers,
      //           parentId: 711,
      //           auth: false,
      //         },
      //         {
      //           id: 7113,
      //           label: "MENUITEMS.FINANCE.LIST.REPORTS.LIST.STATEMENTOFACCOUNT",
      //           link: AppRoutes.finance.reports.stateOfAccount,
      //           parentId: 711,
      //           auth: true,
      //         },
      //         {
      //           id: 7114,
      //           label: "MENUITEMS.FINANCE.LIST.REPORTS.LIST.TRIALBALANCE",
      //           link: AppRoutes.finance.reports.trialBalance,
      //           parentId: 711,
      //           auth: false,
      //         },
      //       ],
      //     },
      //     {
      //       id: 712,
      //       label: "MENUITEMS.FINANCE.LIST.ARCHIVES.TEXT",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //       subItems: [
      //         {
      //           id: 7121,
      //           parentId: 712,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 713,
      //       label: "MENUITEMS.FINANCE.LIST.BUDGET.TEXT",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //       subItems: [
      //         {
      //           id: 7131,
      //           parentId: 713,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 714,
      //       label: "MENUITEMS.FINANCE.LIST.ALLOCATIONNETTING.TEXT",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //       subItems: [
      //         {
      //           id: 7141,
      //           parentId: 714,
      //           auth: true,
      //         },
      //       ],
      //     },
      //     {
      //       id: 715,
      //       label: "MENUITEMS.FINANCE.LIST.DATAMAPPING",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 716,
      //       label: "MENUITEMS.FINANCE.LIST.DIFFERENCEINEXCHANGE",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 717,
      //       label: "MENUITEMS.FINANCE.LIST.CLOSEFINANCIALYEAR",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 718,
      //       label: "MENUITEMS.FINANCE.LIST.DATALOCK",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 719,
      //       label: "MENUITEMS.FINANCE.LIST.FINANCIALSETTINGS",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //     {
      //       id: 720,
      //       label: "MENUITEMS.FINANCE.LIST.OPENBALANCE",
      //       link: AppRoutes.finance.chequesManagement,
      //       parentId: 7,
      //       auth: false,
      //     },
      //   ],
      // },
      // {
      //   id: 8,
      //   label: "MENUITEMS.HUMANRESOURCES.TEXT",
      //   icon: "ri-team-line",
      //   // link: AppRoutes.Panel.base,
      //   auth: false,
      // },
      // {
      //   id: 9,
      //   label: "MENUITEMS.FIXEDASSETS.TEXT",
      //   icon: "mdi mdi-home-city-outline",
      //   // link: AppRoutes.Panel.base,
      //   auth: false,
      // },
      {
        id: 12,
        label: "MENUITEMS.ITDEPARTMENT.TEXT",
        icon: "ri-customer-service-2-fill",
        auth: false,
        subItems: [
          {
            id: 1202,
            label: "MENUITEMS.ITDEPARTMENT.LIST.REQUESTS",
            link: AppRoutes.ITDepartment.requests,
            parentId: 12,
            auth: false,
          },
          {
            id: 1201,
            label: "MENUITEMS.ITDEPARTMENT.LIST.MANAGEMENT",
            link: AppRoutes.ITDepartment.base,
            parentId: 12,
            auth: false,
          },
        ],
      },
      {
        id: 10,
        label: "MENUITEMS.STAFFPANEL.TEXT",
        icon: "bx bx-user",
        link: AppRoutes.Panel.base,
        auth: true,
      },
      {
        id: 11,
        label: "MENUITEMS.SYSTEMADMIN.TEXT",
        icon: "ri-user-settings-line",
        auth: privileges.SystemAdmin?.includes(
          SystemAdminPermissions.ChSystemAdmin,
        ),
        subItems: [
          {
            id: 1101,
            label: "MENUITEMS.SYSTEMADMIN.LIST.MANAGEMENT",
            link: AppRoutes.SystemAdmin.base,
            parentId: 11,
            auth: privileges.SystemAdmin?.includes(
              SystemAdminPermissions.ChUsersMang,
            ),
          },
          {
            id: 1102,
            label: "MENUITEMS.SYSTEMADMIN.LIST.CLIENTSPORTAL",
            link: AppRoutes.SystemAdmin.clientPortal,
            parentId: 11,
            auth: privileges.SystemAdmin?.includes(
              SystemAdminPermissions.ChOnlinePortalUsersAccounts,
            ),
          },
        ],
      },
    ];
  }
}
